import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import RegistrationBreach from './RegistrationBreach';
import RegistrationSuccess from './RegistrationSuccess';
import SubscriptionBreach from './SubscriptionBreach';

const nonSubscriptionSites = [ 'newscomau' ];

const getTextValuesForTool = (type) => {
  switch (type) {
  case 'poll':
    return {
      thankYouText: 'Thanks for your vote.',
      loginIncentiveText: 'to view results.',
      displayName: 'poll'
    };
  case 'quiz':
    return {
      thankYouText: 'Thanks for participating.',
      messageSuffix: 'to view results.',
      displayName: 'quiz'
    };
  case 'personalityquiz':
    return {
      thankYouText: 'Thanks for participating.',
      messageSuffix: 'to view results.',
      displayName: 'personality quiz'
    };
  case 'toplist':
    return {
      thankYouText: 'Please login or register to view this list.',
      messageSuffix: '',
      displayName: 'toplist'
    };
  case 'supervoter':
    return {
      thankYouText: 'Hey SuperVoter! Please login or register to have your say.',
      messageSuffix: '',
      displayName: 'supervoter'
    };
  case 'competition':
    return {
      thankYouText: '',
      messageSuffix: 'to continue',
      displayName: 'competition'
    };
  default:
    return {
      thankYouText: '',
      messageSuffix: 'to continue',
      displayName: 'feature'
    };
  }
};

const StandardRegistrationContent = ({
  type,
  isLocked,
  siteId,
  showForm,
  showSuccess,

  formRef,
  testButtonRef,

  handleRegister,
  handleLogin,
  handleClose,
}) => {
  const { thankYouText, loginIncentiveText, displayName } = getTextValuesForTool(type);
  const introTitleFormatted = thankYouText.split('\n').map(
    (item, i) => (
      <Fragment key={i}>
        {(i > 0) && (<br />)}
        {item}
      </Fragment>
    )
  );

  return (
    <>
      {showSuccess && <RegistrationSuccess handleClose={handleClose} />}

      {isLocked && (
        nonSubscriptionSites.includes(siteId) ?
          <>
            {!showForm && (
              <RegistrationBreach
                topText={introTitleFormatted}
                bottomText={loginIncentiveText}
                handleLogin={handleLogin}
                handleRegister={handleRegister}
                siteId={siteId}
              />
            )}

            {showForm && <div className="et-common_registration_form" ref={formRef} />}

            <div className="et-common_registration_button_test" ref={testButtonRef}>Test registration complete</div>
          </> : <>
            {!showForm && (
              <SubscriptionBreach
                topText={'Premium Content'}
                bottomText={`Register or log in to use this feature`}
                handleLogin={handleLogin}
                handleSubscribe={handleRegister}
                siteId={siteId}
              />
            )}

            {showForm && <div className="et-common_registration_form" ref={formRef} />}

            <div className="et-common_registration_button_test" ref={testButtonRef}>Test subscription complete</div>
          </>
      )}
    </>
  );
};

StandardRegistrationContent.propTypes = {
  type: PropTypes.string.isRequired,
  isLocked: PropTypes.bool.isRequired,
  siteId: PropTypes.string.isRequired,
  showForm: PropTypes.bool.isRequired,
  showSuccess: PropTypes.bool.isRequired,

  handleRegister: PropTypes.func.isRequired,
  handleLogin: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default StandardRegistrationContent;
